import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-scora-ghost-card-module',
  templateUrl: './scora-ghost-card-module.component.html',
  styleUrls: ['./scora-ghost-card-module.component.css']
})
export class ScoraGhostCardModuleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/application/core-module/scora-ghost-card-module/scora-ghost-card-module.component.ts